// Importing the required type for conveyance data
import { IConveyanceServiceResponse } from "../../../features/conveyance/types";
import { IBaseResponse } from "../../../Types/UserProfileDetails";

// Importing the base ApiService class to inherit HTTP request functionality
import ApiService from "../../ApiService";

enum ConveyanceEndpoints {
  CONVEYANCE_DETAILS = "/employee/conveyance",
  APPLY_CONVEYANCE = "/employee/conveyance/apply",
  DELETE_CONVEYANCE = "/employee/conveyance/delete",
}

export interface IDeleteConveyanceUser extends IBaseResponse {
  data: {
    deleted_id: number;
  };
}

// Defining the ConveyanceService class that extends ApiService to interact with the conveyance-related API
class ConveyanceService extends ApiService {
  // Method to fetch conveyance details for a specific user
  async getConveyanceDetails(
    user: string,
    startDate?: string,
    endDate?: string,
    activeYear?: number,
    page?: number,
    size?: number
  ): Promise<IConveyanceServiceResponse> {
    // Making a GET request to fetch the conveyance details with optional date filters
    return this.get<IConveyanceServiceResponse>(
      `${ConveyanceEndpoints.CONVEYANCE_DETAILS}/${user}?active_year=${activeYear}&start_date=${startDate}&end_date=${endDate}&page=${page}&size=${size}`
    );
  }

  // Method to apply for conveyance using the provided form data
  async applyConveyance(conveyanceFormData: FormData) {
    return this.post<IBaseResponse>(
      ConveyanceEndpoints.APPLY_CONVEYANCE,
      conveyanceFormData
    );
  }

  async deleteConveyance(deleteConveyanceData: { id: number }) {
    return this.post<IDeleteConveyanceUser>(
      ConveyanceEndpoints.DELETE_CONVEYANCE,
      deleteConveyanceData
    );
  }
}

// Creating an instance of the ConveyanceService class and exporting it for use in other parts of the application
export const conveyanceService = new ConveyanceService();
